export const isAimsSourceImage = (url) => {
  const aimsRegex = /s-nbcnews\.com\/i/i;
  return aimsRegex.test(url);
};

export const isAimsUrl = (url) => {
  const aimsRegex = /s-nbcnews\.com\/j/i;
  return aimsRegex.test(url);
};

export const isNbcHostedUrlImage = (url) => {
  if (!url) {
    return false;
  }
  const nbcHostedRegex = /s-nbcnews\.com/i;
  return nbcHostedRegex.test(url);
};

export const isTelemundoHostedImage = (url) => {
  if (!url) {
    return false;
  }
  const telemundoHostedRegex = /\/nbcutelemundo/i;
  return telemundoHostedRegex.test(url);
};

// Convert aims url back to the source.
export const getAimsSourceImage = (url) => {
  if (!isAimsUrl(url)) {
    return url;
  }

  return url.replace(/com\/j\//, 'com/i/')
    .replace(/\.[^/]+\.(?=jpe*g|gif|png)/i, '.');
};

export const isResizableImage = (url) => isNbcHostedUrlImage(url) || isTelemundoHostedImage(url);
